import React from 'react'
import { Avatar, Box, Typography } from '@material-ui/core'
import { getBaseURL } from 'service/env'
import PropTypes from 'prop-types'

import useStyles from './styles'

const SupplierDetails = ({ company }) => {
  const classes = useStyles()

  const logoPath =
    company?.logo?.url && `${getBaseURL('dponet')}${company?.logo?.url}`

  const avatarLetters = (company) =>
    (company?.name || 'Empresa cliente')
      .split(' ')
      .map((word) => word[0])
      .join('')

  return (
    <>
      <Avatar
        className={classes.avatar}
        src={logoPath}
        classes={{ img: classes.img }}
      >
        {avatarLetters(company)[0]}
        {avatarLetters(company)[avatarLetters(company).length - 1]}
      </Avatar>
      <Box display="flex" alignItems="center" flexDirection="column" mt={3}>
        <Typography variant="h3" color="textPrimary" gutterBottom>
          Empresa: {company?.name}
        </Typography>
        <Typography variant="body2" color="textPrimary">
          {company?.document}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" flexDirection="column" mt={2}>
        <Typography variant="subtitle2" color="textPrimary">
          A empresa {company?.name} vinculou a sua empresa para a avaliação de
          fornecedores.
        </Typography>
        <Typography variant="subtitle2" color="textPrimary">
          Valide seus dados básicos para aprovar ou rejeitar o vínculo
        </Typography>
      </Box>
    </>
  )
}

SupplierDetails.propTypes = {
  company: PropTypes.object,
}

export default SupplierDetails
